import { TotalPayouts } from "../raceResult/type";
import { ResultPayouts } from "../raceResult/components/runnerResult/types";

export const numberOfColumnsPayout = (
  totalPayouts: TotalPayouts | ResultPayouts
): number => Object.values(totalPayouts).filter((element) => element).length;
